import { API_URL, GETAPI } from "./config";


export const GET_UNREAD_COUNT = async () => {

    const res = await GETAPI(API_URL.getUnreadCount);
    return res;
  };